import React from "react";
import Chip from "@material-ui/core/Chip";
import Tooltip from "@material-ui/core/Tooltip";

export default function AICaptureBadge({ confidence }) {
  if (confidence == null || confidence < 0.6) return null;
  const color = confidence >= 0.85 ? "#2e7d32" : confidence >= 0.6 ? "#ed6c02" : "#9e9e9e";
  const label = confidence >= 0.85 ? "+IA (Alta)" : confidence >= 0.6 ? "+IA (Verificar)" : "+IA";
  return (
    <Tooltip title={`Capturado por IA - Confianza: ${(confidence * 100).toFixed(0)}%`}>
      <Chip size="small" label={label} style={{ backgroundColor: color, color: "#fff", height: 18 }} />
    </Tooltip>
  );
}
